<template>
  <n-notification-provider>
    <n-message-provider>
      <router-view />
    </n-message-provider>
  </n-notification-provider>
</template>
<script setup lang="ts">
</script>
<style>
.tox.tox-tinymce-aux {
    z-index: 4000;
}

.page-start .content-wrapper{
  background: rgb(241, 229, 199);
}

.page-start .n-page-header-wrapper {
  display: none;
}
</style>
